<template>
  <fragment>
    <HeaderMain />
    <main class="affix-parent">
      <AccessoryMain />
      <router-view></router-view>
    </main>
    <FooterMain />
  </fragment>
</template>

<script>
import postscribe from 'postscribe';

import HeaderMain from '@/components/layout/header/HeaderMain';
import FooterMain from '@/components/layout/footer/FooterMain';
import AccessoryMain from '@/components/layout/accessory/AccessoryMain';


export default {
  name: 'app',
  async beforeMount() {
    this.$store.dispatch('SAVE_PEOPLE_LIST', { role: 'presidente' });
    this.$store.dispatch('SAVE_PEOPLE_LIST', { role: 'relatore' });
    // this.$store.dispatch('SAVE_PEOPLE_LIST', { role: 'giudice' });
  },
  mounted() {
    postscribe(
      '#body',
      // eslint-disable-next-line no-useless-escape
      '<script src="static/bootstrap-italia/dist/js/bootstrap-italia.bundle.min.js"><\/script>',
    );
  },
  components: {
    HeaderMain,
    FooterMain,
    AccessoryMain,
  },
};
</script>

<style lang="less">
  @annoColor: #0073e6;
  @sentenzeColor: #133A3A;
  @ordinanzeColor: #638490;
  @presidenteColor: #1c2331;
  @relatoreColor: #880000;
  @giudiceColor: #00193d;

  .legge-link {
    cursor:pointer;
  }
  .chip svg.icon{
    fill:white!important;
  }
  .anno-bg{
    background-color:@annoColor!important;
    border: 1px solid white;
    color:white!important;
  }
  .anno-text{
    color:@annoColor!important;
  }
  .sentenze-bg{
    background-color:@sentenzeColor!important;
    border: 1px solid white;
    color:white!important;
  }
  .sentenze-text{
    color:@sentenzeColor!important;
  }
  .sentenze-link {
    color:@sentenzeColor!important;
    border-bottom: 3px double @sentenzeColor;
    cursor: pointer;
  }
  .ordinanze-bg{
    background-color:@ordinanzeColor!important;
    border: 1px solid white;
    color:white!important;
  }
  .ordinanze-text{
    color:@ordinanzeColor!important;
  }
  .ordinanze-link {
    color:@ordinanzeColor!important;
    border-bottom: 3px double @ordinanzeColor;
    cursor: pointer;
  }
  .giudice-bg{
    background-color:@giudiceColor!important;
    border: 1px solid white;
    color:white!important;
  }
  .giudice-text{
    color:@giudiceColor!important;
  }
  .presidente-bg{
    background-color:@presidenteColor!important;
    border: 1px solid white;
    color:white!important;
  }
  .presidente-text{
    color:@presidenteColor!important;
  }
  .relatore-bg{
    background-color:@relatoreColor!important;
    border: 1px solid white;
    color:white!important;
  }
  .relatore-text{
    color:@relatoreColor!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue